module.exports = __webpack_public_path__ + "img/RAID-fond-blanc.b2a8a8d0.png";